// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__KBkjS","item":"NotFound_item__PxAv3"};